import { render, staticRenderFns } from "./versorteo.vue?vue&type=template&id=4b496a4f&"
import script from "./versorteo.vue?vue&type=script&lang=js&"
export * from "./versorteo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports